import React from "react";
import IconCloseX from "@components/Icons/IconCloseX";
import styles from "./Modal.module.scss";

const Modal = ({ show, close, children }) => {
  return (
    <>
      {show 
      ? <div
          className={styles.modalContainer}
          onClick={() => close()}
        >
          <div 
            className={styles.modal} 
            onClick={(e) => e.stopPropagation()}
          >
            <div> {children} </div>
            <div className={styles.close} onClick={() => close()}>
              <IconCloseX />
            </div>
          </div>  
        </div>
      : null
      }
    </>
  );
};

export default Modal;